import { render } from "./AdminSideMenu.vue?vue&type=template&id=f8604eec"
import script from "./AdminSideMenu.vue?vue&type=script&lang=js"
export * from "./AdminSideMenu.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./AdminSideMenu.vue?vue&type=style&index=0&id=f8604eec&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/home/runner/work/sma-order/sma-order/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__